import * as React from "react";

const SvgIcnArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M8.113 14.797a.626.626 0 01-.922 0 .723.723 0 010-.979l4.35-4.615a.626.626 0 01.923 0l4.345 4.61a.723.723 0 010 .978.626.626 0 01-.922 0l-3.884-4.12-3.89 4.126z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnArrowUp;
